import * as React from "react";
const SvgArrowDownSFill = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path fill="none" d="M0 0h24v24H0z" /><path d="m12 16-6-6h12z" /></svg>;
export default SvgArrowDownSFill;